import { useQuery } from "@tanstack/react-query";

import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

const useSfEnrichmentJobQuery = (jobId: string) => {
    return useQuery({
        enabled: !!jobId,
        queryKey: salesforceEnrichmentQueryKeys.job(jobId),
        queryFn({ signal }) {
            return sfEnrichmentApiService.getJob(jobId, {
                cancellation: signal,
            });
        },
        staleTime: 60 * 1000,
    });
};

export default useSfEnrichmentJobQuery;
